import { render, staticRenderFns } from "./CreateNewRide.vue?vue&type=template&id=c0b4c418&"
import script from "./_CreateNewRide.js?vue&type=script&lang=js&"
export * from "./_CreateNewRide.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports